export enum DataType {
  ARTICLE = 'article',
  CATEGORY = 'category',
  SECTION = 'section',
}
